var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filterreset") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "#FF8100",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager---Diensten---Inplannen---Maand",
    transform: "translate(-20.000000, -667.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filterreset",
    transform: "translate(20.000000, 549.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91666667,4.16666667 C10.9082091,4.16666667 13.3333333,6.59179094 13.3333333,9.58333333 C13.3333333,12.5748757 10.9082091,15 7.91666667,15 L5,15 L5,13.3333333 L7.91666667,13.3333333 C10,13.3333333 11.6666667,11.6666667 11.6666667,9.58333333 C11.6666667,7.5 10,5.83333333 7.91666667,5.83333333 L3.19166667,5.83333333 L5.75833333,8.40833333 L4.58333333,9.58333333 L0,5 L4.58333333,0.416666667 L5.76666667,1.59166667 L3.19166667,4.16666667 L7.91666667,4.16666667 L7.91666667,4.16666667 Z M1.66666667,13.3333333 L3.33333333,13.3333333 L3.33333333,15 L1.66666667,15 L1.66666667,13.3333333 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.bfc120de4a6a92144f3569dbcc32b0cf.svg";
export { ForwardRef as ReactComponent };